import { render, staticRenderFns } from "./ProtestInfo.vue?vue&type=template&id=ca6464ba&"
import script from "./ProtestInfo.vue?vue&type=script&lang=js&"
export * from "./ProtestInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports